import store from "../store";

const routeLeave = (to, from, next) => {
    from.meta.leaving = true
    const t = (to.meta.guard && to.meta.guard.type)
    const f = (from.meta.guard && from.meta.guard.type)

    if (t && f && (t === f))
        next()
    else {
        store.commit('record_stop')
        next()
    }
}

export default routeLeave